import {
  encodeGetParams,
  GET,
  getFetchResult,
  getIAPIAuthCheck,
  getIAPIFetchResult,
  PATCH,
  POST,
  PUT,
} from "./common";

export const addSurvey = async ({
  sid,
  lecture_id,
  title,
  contents,
  questions,
  options,
  target,
}) => {
  const result = await getFetchResult(`survey`, POST, {
    sid,
    lecture_id,
    title,
    contents,
    target,
    questions,
    options,
  });
  return result;
};

export const deleteSurvey = async (id) => {
  const result = await getFetchResult(`survey/${id}`, PATCH, {});
  return result;
};

export const getSurvey = async ({ id, target }) => {
  if (!id) return { result: false };
  const result = await getFetchResult(
    `survey/${id}?${encodeGetParams({ target })}`,
    GET
  );
  return result;
};

export const getSurveyResults = async ({ lecture_id, target }) => {
  if (!lecture_id) return { result: false };
  const result = await getFetchResult(
    `survey/result/${lecture_id}?${encodeGetParams({ target })}`,
    GET
  );
  return result;
};

export const getSurveyForUpdate = async ({ sid }) => {
  if (!sid) return { result: false };
  const result = await getFetchResult(`survey/update/${sid}`, GET);
  return result;
};

export const responseSurvey = async ({
  id,
  user_id,
  target,
  responses,
  requiredTime,
}) => {
  const result = await getFetchResult(`survey/response`, POST, {
    id,
    user_id,
    target,
    responses,
    requiredTime,
  });
  return result;
};

export const uploadSurvey = async ({ id, files }) => {
  const formData = new FormData();
  formData.append("file", files[0]);
  const result = await getFetchResult(
    `survey/merge?${encodeGetParams({ id })}`,
    POST,
    formData,
    true
  );
  return result;
};

export const findLecture = async (params) => {
  const result = await getFetchResult(
    `find/lecture?${encodeGetParams(params)}`,
    GET
  );
  return result;
};

export const registLecture = async ({ lecture_id, student_id: id }) => {
  const result = await getFetchResult(`regist`, POST, { lecture_id, id });
  return result;
};

export const getLecture = async ({ lecture_id: id, sort, asc }) => {
  const url = id
    ? `lecture/${id}`
    : `lecture${sort ? "?" + encodeGetParams({ sort, asc }) : ""}`;
  const result = await getFetchResult(url, GET);
  return result;
};

export const setLecture = async (params) => {
  const result = await getFetchResult(`lecture`, POST, params);
  return result;
};

export const addLecture = async (params) => {
  const result = await getFetchResult(`lecture`, POST, params);
  return result;
};
export const deleteLecture = async (id) => {
  const result = await getFetchResult(`lecture/${id}`, PATCH, {});
  return result;
};

export const getQuiz = async ({ qid }) => {
  if (!qid) return { result: false };
  const result = await getFetchResult(`quiz/${qid}`, GET);
  return result;
};
export const getQuizForApply = async ({ qid, student_id }) => {
  if (!qid || !student_id) return { result: false };
  const result = await getFetchResult(
    `quiz/${qid}?${encodeGetParams({ student_id })}`,
    GET
  );
  return result;
};

export const getQuizResult = async ({
  lecture_id,
  student_id,
  parent_id,
  quiz_id,
}) => {
  if (!lecture_id || !(student_id || parent_id)) return { result: false };
  const obj = student_id ? { quiz_id, student_id } : { quiz_id, parent_id };
  const result = await getFetchResult(
    `quiz_result/${lecture_id}?${encodeGetParams(obj)}`,
    GET
  );
  return result;
};

export const addQuiz = async ({
  qid,
  lecture_id,
  title,
  contents,
  questions,
  options,
  answers,
}) => {
  const result = await getFetchResult(`quiz`, POST, {
    qid,
    lecture_id,
    title,
    contents,
    questions,
    options,
    answers,
  });
  return result;
};

export const deleteQuiz = async (id) => {
  const result = await getFetchResult(`quiz/${id}`, PATCH, {});
  return result;
};

export const responseQuiz = async ({
  qid,
  student_id,
  lecture_id,
  responses,
  requiredTime,
}) => {
  const result = await getFetchResult(`quiz/response`, POST, {
    qid,
    student_id,
    lecture_id,
    responses,
    requiredTime,
  });
  return result;
};

export const addUser = async ({ files, lecture_id, type }) => {
  const formData = new FormData();
  formData.append("file", files[0]);
  formData.append("lecture_id", lecture_id);
  formData.append("type", type);
  const result = await getIAPIFetchResult(
    "upload/themaker",
    POST,
    formData,
    true
  );
  return result;
};

export const getUserLectureList = async () => {
  const result = await getFetchResult("user/lectures", GET);
  return result;
};

export const getUsersByLecture = async ({ id, sort, asc }) => {
  const result = await getFetchResult(
    `users/${id}?${encodeGetParams({ sort, asc })}`,
    GET
  );
  return result;
};

export const getAttendanceList = async (id) => {
  const result = await getFetchResult(`attendance/${id}`, GET);
  return result;
};

export const updateAttendance = async (data) => {
  const { lecture_id, student_id, record, curriculumIndex } = data;
  const result = await getFetchResult(`attendance`, PATCH, {
    lecture_id,
    student_id,
    record,
    curriculumIndex,
  });
  return result;
};

export const getParentInfo = async (key) => {
  const result = await getFetchResult(`parents/${key}`, GET);
  return result;
};

export const getStudentInfo = async (id) => {
  const result = await getFetchResult(`students/${id}`, GET);
  return result;
};

export const getStudentDashboardInfo = async (id, item) => {
  const result = await getFetchResult(
    `student/${id}?${encodeGetParams({ item })}`,
    GET
  );
  return result;
};

export const getReportData = async ({ lecture_id, student_id, parent_id }) => {
  if (!lecture_id || !(student_id || parent_id)) return { result: false };
  const obj = student_id ? { student_id } : { parent_id };
  const result = await getFetchResult(
    `report/${lecture_id}?${encodeGetParams(obj)}`,
    GET
  );
  return result;
};

export const getCertificateData = async ({ id }) => {
  if (!id) return { result: false };
  const obj = { lecture_id: id };
  const result = await getFetchResult(
    `certificate?${encodeGetParams(obj)}`,
    GET
  );
  return result;
};
export const getViewCertificateData = async ({ id, student_id }) => {
  if (!id || !student_id) return { result: false };
  const obj = { id, student_id };
  const result = await getFetchResult(
    `certificate/view?${encodeGetParams(obj)}`,
    GET
  );
  return result;
};
export const getCertificateLogo = async (fileId) => {
  if (!fileId) return null;
  const result = await getFetchResult(`certificate/${fileId}`, GET);
  return result;
};

export const signInUser = async (data) => {
  const result = await getIAPIFetchResult("signin", POST, data);
  return result;
};
export const signOutUser = async (data) => {
  const result = await getIAPIFetchResult("signout", PATCH, data);
  return result;
};
export const signInStudent = async (data) => {
  const result = await getFetchResult("student/signin", POST, data);
  return result;
};
export const signInParent = async (data) => {
  const result = await getFetchResult("parent/signin", POST, data);
  return result;
};
export const checkUserId = async (userId) => {
  const result = await getIAPIFetchResult(
    `check_item?${encodeGetParams({ userId })}`,
    GET
  );
  return result;
};
export const getSchoolsData = async (data) => {
  const result = await getIAPIFetchResult(
    `schools?${encodeGetParams(data)}`,
    GET
  );
  return result;
};

export const getSchoolByCode = async ({ code }) => {
  const result = await getIAPIFetchResult(
    `school?${encodeGetParams({ code })}`,
    GET
  );
  return result;
};

export const sendVerifyForFindOut = async (obj) => {
  const result = await getIAPIFetchResult(
    `find/send_verify?${encodeGetParams(obj)}`,
    GET
  );
  return result;
};

export const confirmVerifyForFindOut = async (obj) => {
  const result = await getIAPIFetchResult(
    `find/confirm_verify?${encodeGetParams(obj)}`,
    GET
  );
  return result;
};

export const sendVerify = async ({ id, tel, email }) => {
  const obj = { id };
  if (tel) {
    obj.tel = tel;
  } else if (email) {
    obj.email = email;
  } else {
    return {
      result: false,
      error: "휴대전화번호 또는 이메일 인증 정보를 입력하세요.",
    };
  }
  const result = await getIAPIFetchResult(
    `send_verify?${encodeGetParams(obj)}`,
    GET
  );
  return result;
};
export const confirmVerify = async ({ id, code }) => {
  const result = await getIAPIFetchResult(
    `confirm_verify?${encodeGetParams({ id, code })}`,
    GET
  );
  return result;
};
export const signUp = async (data) => {
  const result = await getIAPIFetchResult(`signup`, POST, data);
  return result;
};
export const updateUserInfo = async (data) => {
  const result = await getIAPIFetchResult(`update`, PUT, data);
  return result;
};
export const updateUserPassword = async (data) => {
  const result = await getIAPIFetchResult(`update/password`, PUT, data);
  return result;
};

export const getAuth = async (token) => {
  const result = await getIAPIAuthCheck(token);
  return result;
};

export const saveCert = async ({ logoFile, ...rest }) => {
  const formData = new FormData();
  formData.append("file", logoFile);
  Object.entries(rest).map(([k, v]) => {
    formData.append(k, JSON.stringify(v));
    return null;
  });
  const result = await getFetchResult("certificate", POST, formData, true);
  return result;
};
